import { AxiosError } from 'axios';
import { getApiClient } from './api.base';
import { FundraisingHandoverResponse } from '@/models/fundraising-handover-response.model';
import { FundraisingHandoverRequest } from '@/models/fundraising-handover-request.model';

type Response = FundraisingHandoverResponse & AxiosError;

export const fundraisingHandover = async (
  payload: FundraisingHandoverRequest
): Promise<Response> => {
  try {
    const response = await getApiClient('affiliate').post(
      `/api/v1/donate`,
      payload
    );
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    return error;
  }
};
